<template>
	<UiModalMobile
		v-model="modelValue"
		class="modal__mobile"
		:titleBtnSave="storekeeperStore.isSearchMode ? 'Принять груз' : 'Сохранить'"
		:isDontNeedCloseWhenSave="true"
		@save="saveHandler"
		height="calc(100% - 145px)"
		min-height-body="unset"
		:is-loading-btn-save="props.isLoading"
		:is-need-cancel-btn="
			!storekeeperStore?.loading?.virtualCargoGetById && (currentCargo?.allowedNextStatuses?.length || 0) == 0
		"
		:isNeedBtnSave="!storekeeperStore?.loading?.virtualCargoGetById && !currentCargo?.allowedNextStatuses?.length"
	>
		<TypographyKTypographyBody2
			color="var(--color_font_black_wite)"
			font-type="bold"
		>
			{{ $t('Информация о грузе') }}
		</TypographyKTypographyBody2>
		<div class="wrapper">
			<div
				class="content"
				v-if="!storekeeperStore?.loading.virtualCargoGetById"
			>
				<div
					class="cargo-info"
					:style="{ color: currentCargo?.cargoStatus?.backgroundColor }"
				>
					Груз #{{ currentCargo?.number }}
				</div>
				<div class="inputs-wrapper">
					<UiInput
						v-model="payload.weightFact"
						type="number"
						:number-only="true"
						:is-number-only-allow-dots="true"
						label="Вес, т"
					/>
					<UiInput
						v-model="payload.volumeFact"
						type="number"
						:number-only="true"
						:is-number-only-allow-dots="true"
						label="Объем, м3"
					/>
					<UiInput
						v-model="payload.qtyFact"
						type="number"
						:number-only="true"
						:is-number-only-allow-dots="true"
						label="Кол-во"
					/>
					<UiSelect
						max-width="none"
						v-model="payload.quantityTypeId"
						label="Ед.измерения"
						theObjectToBeDisplayed="value"
						:items="dictionariesStrore.quantityType"
					/>
				</div>
				<div class="card-with-items">
					<CommonCardWithItems
						v-model="payload.name"
						label="Свойства груза"
						placeholder="Введите текст"
						:readonly="false"
						:isNeedAlwaysVisibleInput="false"
					>
						<template #opened>
							<div class="checkbox-wrapper">
								<UiCheckBox
									v-for="item in cargoProperties"
									v-model="payload[item.id]"
									:key="item.id"
								>
									<div class="label-text">
										<div
											v-if="item.isPallet"
											class="icon-pallet"
										>
											<Icon
												name="fa7-solid:pallet"
												:color="item.color"
											/>
											<Icon
												name="fa7-solid:pallet"
												class="icon-pallet-bottom"
												:color="item.color"
											/>
										</div>

										<Icon
											v-else
											:name="item.name"
											class="icon-pallet-bottom"
											:color="item.color"
										/>

										<TypographyKTypographyBody4
											font-type="regular"
											color="black"
											class="text"
										>
											{{ item.text }}
										</TypographyKTypographyBody4>
									</div>
								</UiCheckBox>
							</div>
						</template>

						<template #closed>
							<div class="icons-wrapper">
								<template
									v-for="item in cargoProperties"
									:key="item.id"
								>
									<div
										v-if="item.isPallet && payload?.[item.id]"
										class="icon-pallet"
									>
										<Icon
											name="fa7-solid:pallet"
											:color="item.color"
										/>
										<Icon
											name="fa7-solid:pallet"
											class="icon-pallet-bottom"
											:color="item.color"
										/>
									</div>

									<Icon
										v-else-if="payload?.[item.id]"
										:name="item.name"
										:color="item.color"
									/>
								</template>
							</div>
						</template>
					</CommonCardWithItems>
				</div>
				<div class="content-additional">
					<CommonTextAreaSpecialTextArea
						v-model="payload.name"
						label="Название"
						placeholder="Введите текст"
						:readonly="false"
					/>
					<CommonInputSpecialInput
						v-model="payload.clientSender.name"
						label="Отправитель"
						:isNeedChangeBtn="true"
						:readonly="true"
						:is-disabled="props.currentCargo?.cargoId"
						@clickBtn="chooseClientModal(TClientType.Sender)"
					/>
					<CommonInputSpecialInput
						v-model="payload.clientRecipient.name"
						label="Получатель"
						:isNeedChangeBtn="true"
						:readonly="true"
						:is-disabled="props.currentCargo?.cargoId"
						@clickBtn="chooseClientModal(TClientType.Recipient)"
					/>
					<CommonInputSpecialInput
						v-model="payload.city.name"
						label="Город"
						:isNeedChangeBtn="true"
						:readonly="true"
						:is-disabled="props.currentCargo?.cargoId"
						@clickBtn="chooseCityModal"
					/>
					<CommonTextAreaSpecialTextArea
						v-model="payload.comment"
						label="Комментарий"
						placeholder="Введите текст"
						:readonly="false"
					/>
				</div>
				<div class="content__images">
					<UiButtonFile
						:color="ButtonType.primary"
						:size="ButtonSizeType.small"
						:label="'Добавить фото'"
						:isMultiple="true"
						:is-loading="loading.uploadPhoto"
						@load="uploadNewFile"
					>
						<UiIcon
							name="camera"
							folder="cargos"
							width="20px"
							height="20px"
							color="var(--white)"
						/>
					</UiButtonFile>
					<div
						class="images"
						v-if="photoList?.length"
					>
						<div
							class="image"
							v-for="(image, index) in photoList"
						>
							<UiImage
								lazy="lazy"
								:src="image.urlPreview || image?.blobUrl"
								@click.stop="openModalInFullSize(index)"
							/>
							<UiButtonIcon
								background="var(--white)"
								padding="4px"
								class="btn_remove"
								@click="deleteImageHandler(image)"
							>
								<UiIcon
									name="remove"
									folder="button"
									width="19px"
									height="19px"
								/>
							</UiButtonIcon>
						</div>
						<div class="loader-wrapper">
							<UiLoader
								v-if="loading.uploadPhoto"
								class="ui-loader"
								:circle-width="2"
								:radius="14"
								:color="'var(--bg-primary)'"
							/>
						</div>
					</div>
				</div>
			</div>
			<div
				v-else
				class="loader"
			>
				<UiLoaderLottie />
			</div>
		</div>
	</UiModalMobile>
	<UiModalConfirm
		v-if="isOpenConfirmDeleteImageModal"
		v-model="isOpenConfirmDeleteImageModal"
		title="Вы уверены, что хотите удалить изображение?"
		:is-need-save-btn="true"
		@save="confirmDeleteImageHandler"
	/>
	<UiModalImagesModal
		v-if="isOpenModalFullScreenImage"
		:initial-index="initialIndexImage"
		v-model="isOpenModalFullScreenImage"
		:images="listImages"
	/>
	<PagesStorekeeperFindSenderOrReceiver
		:currentCargo="payload"
		:typeClients="typeClients"
		v-model="modals.chooseClientModal"
		v-if="modals.chooseClientModal"
		@chooseClient="chooseClient"
	/>
	<PagesStorekeeperFindCity
		v-model="modals.chooseCityModal"
		v-if="modals.chooseCityModal"
		@chooseCity="chooseCity"
	/>
</template>

<script setup lang="ts">
	import { AlertsTypes } from '~/const/notification';
	import { useDictionariesStore } from '~/store/dictionaries.store';
	import { useNotificationStore } from '~/store/notification.store';
	import { useReceptionPhotoStore } from '~/store/receptionPhoto';
	import { useStorekeeperStore } from '~/store/storekeeper.store';
	import type { ICargoComment, ICargoImage } from '~~/shared/interfaces/driverRequests';
	import { TClientType, type IClient } from '~~/shared/interfaces/storekeeperClient';
	import { ButtonSizeType, ButtonType } from '~~/shared/interfaces/ui';

	const emits = defineEmits(['save']);
	const modelValue = defineModel('modelValue', { required: true, type: Boolean });
	const props = withDefaults(
		defineProps<{
			currentCargo?: any;
			currentCargoId: string;
			isLoading?: boolean;
			warehouseId?: string;
		}>(),
		{}
	);

	const storekeeperStore = useStorekeeperStore();
	const dictionariesStrore = useDictionariesStore();
	const receptionPhotoStore = useReceptionPhotoStore();
	const notificationStore = useNotificationStore();
	const isOpenConfirmDeleteImageModal = ref(false);
	const currentImage = ref<ICargoImage | null>(null);
	const initialIndexImage = ref<number | null>(null);
	const isOpenModalFullScreenImage = ref(false);
	const photoList = ref([]);
	const loading = reactive({
		saveSize: false,
		uploadPhoto: false
	});
	const modals = reactive({
		chooseClientModal: false,
		chooseCityModal: false
	});
	const isNeedShowLoadingScreen = ref(false);
	const typeClients = ref(TClientType.Sender);

	const cargoProperties = [
		{
			id: 'hasPallets',
			text: 'Распалечиваем',
			color: '#FF7F50',
			isPallet: true
		},
		{
			id: 'isOversized',
			name: 'streamline:shipping-transfer-cart-package-box-fulfillment-cart-warehouse-shipping-delivery',
			text: 'Негабарит',
			color: '#AF8100'
		},
		{
			id: 'hasDocuments',
			name: 'fluent:document-checkmark-20-regular',
			text: 'Есть документы',
			color: '#14AB87'
		},
		{
			id: 'isFragile',
			name: 'streamline:shipping-box-fragile-fragile-shipping-glass-delivery-wine-crack-shipment-sign-sticker',
			text: 'Хрупкий',
			color: '#E32F3E'
		},
		{
			id: 'hasFito',
			name: 'lucide:leaf',
			text: 'Выписано ФИТО',
			color: '#1DB12A'
		},
		{
			id: 'hasSnt',
			name: 'fluent:document-bullet-list-16-regular',
			text: 'Поданы СНТ',
			color: '#006EA9'
		}
	];

	const payload = ref<any>({
		warehouseId: props.warehouseId,
		quantityTypeId: null,
		weightFact: '',
		volumeFact: '',
		qtyFact: '',
		clientSenderId: null,
		clientSender: { name: '' },
		clientRecipient: { name: '' },
		clientRecipientId: null,
		city: { name: '' },
		cityId: null,
		name: '',
		comment: '',
		hasDocuments: false,
		hasPallets: false,
		hasSnt: false,
		hasFito: false,
		isOversized: false,
		isFragile: false
	});

	const listImages = computed(() => {
		return (
			photoList.value.map((i) => {
				return { preview: i.urlPreview, url: i.urlOriginal };
			}) || []
		);
	});

	const chooseCityModal = () => {
		modals.chooseCityModal = true;
	};
	const chooseClientModal = (type: TClientType) => {
		typeClients.value = type;
		modals.chooseClientModal = true;
	};

	const chooseCity = (p: any) => {
		payload.value.city = p;
		payload.value.cityId = p?.id;
	};

	const chooseClient = (client: IClient, typeClient: TClientType) => {
		if (!payload.value?.id) {
			payload.value = { ...payload.value, id: props.currentCargo?.id };
		}

		if (typeClient === TClientType.Sender) {
			payload.value.clientSenderId = client.id;
			payload.value.clientSender = client;
		} else if (typeClient === TClientType.Recipient) {
			payload.value.clientRecipientId = client.id;
			payload.value.clientRecipient = client;
		}
	};

	const currentCargo = storeToRefs(storekeeperStore).currentCargo;

	const errorField = ref({
		text: { status: false, msg: '' }
	});

	const openModalInFullSize = (index: number) => {
		initialIndexImage.value = index;
		setTimeout(() => {
			isOpenModalFullScreenImage.value = true;
		});
	};

	const virtualCargoGetById = async (isNeedLoad = true) => {
		if (storekeeperStore.isSearchMode && props.currentCargo) {
			storekeeperStore.currentCargo = props.currentCargo;
			payload.value = {
				...props.currentCargo,
				...(!storekeeperStore.isSearchMode
					? { id: props.currentCargo?.id }
					: { id: null, cargoId: props.currentCargo?.id }),
				...payload.value,
				warehouseId: props.warehouseId,
				weightFact: props.currentCargo?.weightFact,
				volumeFact: props.currentCargo?.volumeFact,
				qtyFact: props.currentCargo?.qtyFact,
				quantityTypeId: props.currentCargo?.quantityTypeId,
				clientRecipientId: props.currentCargo?.clientRecipientId,
				clientRecipient: props.currentCargo?.clientRecipient || { name: '' },
				clientSenderId: props.currentCargo?.clientSenderId,
				clientSender: props.currentCargo?.clientSender || { name: '' },
				cityId: props.currentCargo?.cityId,
				city: props.currentCargo?.city || { name: '' },
				comment: props.currentCargo?.comment,
				name: props.currentCargo?.name,
				hasDocuments: props.currentCargo?.hasDocuments,
				hasPallets: props.currentCargo?.hasPallets,
				hasSnt: props.currentCargo?.hasSnt,
				hasFito: props.currentCargo?.hasFito,
				isOversized: props.currentCargo?.isOversized,
				isFragile: props.currentCargo?.isFragile
			};
			return;
		}

		if (!props.currentCargoId) return;

		const response = await storekeeperStore.virtualCargoGetById({ id: props.currentCargoId }, isNeedLoad);

		if (response.status === 'success') {
			payload.value = {
				...payload.value,
				...response.data,
				id: currentCargo.value?.id,
				warehouseId: currentCargo.value?.warehouseId,
				weightFact: currentCargo.value?.weightFact,
				volumeFact: currentCargo.value?.volumeFact,
				qtyFact: currentCargo.value?.qtyFact,
				quantityTypeId: currentCargo.value?.quantityTypeId
			};
			setQuantityTypeId();
		}
	};

	const deleteImageHandler = async (image: ICargoImage) => {
		currentImage.value = image;
		setTimeout(() => {
			isOpenConfirmDeleteImageModal.value = true;
		});
	};

	const confirmDeleteImageHandler = async () => {
		const saveId = currentImage.value!.id;
		if (!props.currentCargo?.id || !saveId) {
			photoList.value = photoList.value.filter(
				(i: any) => i?.id !== saveId || i?.customId !== currentImage.value?.customId
			);
			isOpenConfirmDeleteImageModal.value = false;
			return;
		}

		const response = await receptionPhotoStore.receptionPhotoDelete({
			id: saveId,
			virtualCargoId: props.currentCargo?.id
		});

		if (response.status === 'success') {
			isOpenConfirmDeleteImageModal.value = false;

			photoList.value = photoList.value.filter((i: any) => i?.id !== saveId);
		}
	};

	const uploadNewFile = async (file: { file: File }[]) => {
		loading.uploadPhoto = true;
		if (props.currentCargo?.id && !storekeeperStore.isSearchMode) {
			await saveUploadFiles(file);
		} else {
			photoList.value.push(...file.map((f) => ({ ...f, customId: Math.random() })));
		}

		loading.uploadPhoto = false;
	};

	const saveUploadFiles = async (file: { file: File }[], cargoId?: string) => {
		if (file?.length) loading.uploadPhoto = true;
		const response = await receptionPhotoStore.uploadReceptionPhoto({
			virtualCargoId: cargoId || props.currentCargo?.id,
			files: file.map((f) => f.file)
		});
		if (response.status) {
			getReceptionPhoto();
		}
		loading.uploadPhoto = false;
	};

	const preparePayload = (obj: any): any => {
		if (typeof obj !== 'object' || obj === null) {
			return obj;
		}

		if (Array.isArray(obj)) {
			return obj
				.map((item) => preparePayload(item))
				.filter(
					(item) =>
						item !== '' &&
						item !== null &&
						item !== undefined &&
						(typeof item !== 'object' || Object.keys(item).length > 0)
				);
		}

		return Object.keys(obj).reduce((acc: any, key: string) => {
			const value = obj[key];
			const cleanedValue = preparePayload(value);

			if (cleanedValue === null || cleanedValue === undefined || cleanedValue === '') {
				return acc;
			}

			if (typeof cleanedValue === 'object' && Object.keys(cleanedValue).length === 0) {
				return acc;
			}

			acc[key] = cleanedValue;
			return acc;
		}, {});
	};

	const saveHandler = async () => {
		const savePayload = { ...preparePayload(payload.value) };
		if (props.currentCargo?.cargoId || storekeeperStore.isSearchMode) {
			delete savePayload.clientSender;
			delete savePayload.clientSenderId;
			delete savePayload.clientRecipient;
			delete savePayload.clientRecipientId;
			delete savePayload.city;
			delete savePayload.cityId;
		}
		if (savePayload?.quantityTypeId?.key) {
			savePayload.quantityTypeId = savePayload.quantityTypeId.key;
		}
		const response = await storekeeperStore.virtualCargoSave(savePayload);

		if (response.status === 'success') {
			const checkPhotoList = photoList.value.filter((f) => f?.blobUrl);

			if (checkPhotoList?.length) {
				await saveUploadFiles(checkPhotoList, response.data?.id);
			}

			if (!props.currentCargo?.id || storekeeperStore.isSearchMode) {
				isNeedShowLoadingScreen.value = true;
				notificationStore.addNewAlert('Груз успешно создан', 4000, AlertsTypes.SUCCESS);
			}
		}
		modelValue.value = false;
	};
	const setQuantityTypeId = () => {
		if (payload.value.quantityTypeId && !payload.value.quantityTypeId?.key && dictionariesStrore.quantityType?.length) {
			payload.value.quantityTypeId = dictionariesStrore.quantityType?.find(
				(q) => q.key === payload?.value.quantityTypeId
			);
		}
	};

	const getReceptionPhoto = async () => {
		if (!props.currentCargoId || storekeeperStore.isSearchMode) return;
		const response = await receptionPhotoStore.getReceptionPhotoByVirtualCargo({
			virtualCargoId: props.currentCargo?.id
		});

		if (response.status === 'success') {
			photoList.value = response.data;
		}
	};

	virtualCargoGetById();
	dictionariesStrore.getQuantityType().then(() => {
		setQuantityTypeId();
	});
	getReceptionPhoto();

	onMounted(() => {
		storekeeperStore.isEditMode = true;
	});
	onUnmounted(() => {
		storekeeperStore.resetCurrentCargo();
		storekeeperStore.isEditMode = false;
		storekeeperStore.getHeaderInfo();
		storekeeperStore.virtualCargoGetAll(isNeedShowLoadingScreen.value);
	});
</script>

<style scoped lang="scss">
	.card-with-items {
		margin-top: 10px;
	}
	.checkbox-wrapper {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 10px;

		@media (max-width: 372px) {
			grid-template-columns: 1fr;
		}
	}
	.label-text {
		display: flex;
		align-items: center;
		gap: 6px;

		@media (max-width: $extra-sm) {
			.text {
				font-size: 12px !important;
			}
		}
	}
	.icon-pallet {
		display: flex;
		flex-direction: column;
		gap: 0px;
		margin-top: -9px;

		.icon-pallet-bottom {
			margin-top: -12px;
		}
	}

	.icons-wrapper {
		display: flex;
		gap: 10px;

		align-items: center;

		@media (max-width: $md) {
			justify-content: space-between;
		}
	}
	.content-additional {
		display: flex;
		flex-direction: column;
		gap: 10px;
		margin-top: 10px;
		padding-bottom: 5px;
	}
	.modal__mobile {
		display: flex;
		flex-direction: column;

		.actions-btn {
			display: grid;
			grid-template-columns: 1fr 1fr;
			grid-gap: 10px;

			&__grid-3 {
				grid-template-columns: 1fr;
			}
			&__grid-1 {
				grid-template-columns: 1fr;
			}
		}

		.content {
			.cargo-info {
				font-weight: 600;
			}
			.inputs-wrapper {
				display: grid;
				grid-template-columns: 1fr 1fr;
				grid-template-rows: 1fr 1fr;
				gap: 5px 10px;
				margin-top: 10px;
			}

			.card {
				padding: 14px 14px;
				background-color: var(--gray-primary);
				border-radius: 12px;
			}

			&__images {
				display: flex;
				flex-direction: column;
				margin-top: 14px;
				margin-bottom: 6px;

				.images {
					display: flex;
					flex-wrap: wrap;
					gap: 15px;
					padding: 4px;
					margin-top: 12px;
					margin-bottom: 10px;

					.image {
						position: relative;
						width: 76px;
						height: 76px;
						min-width: 76px;
						background-repeat: no-repeat;
						background-position: center;
						background-size: cover;
						border-radius: 12px;
						box-shadow: 0px 0px 5.6px 0px #0000001f;
						margin: 2px 0px;

						img {
							width: 76px;
							height: 76px;
							border-radius: 12px;
						}

						.btn_remove {
							position: absolute;
							top: -9px;
							right: -9px;
						}
					}

					.loader-wrapper {
						display: flex;
						justify-content: center;
						align-items: center;
						width: 76px;
						height: 76px;

						.ui-loader {
							width: 100%;
							height: 100%;
							margin: auto;
						}
					}
				}

				.ui-file {
					margin-left: auto;
				}
			}

			&__comments {
				margin-top: 12px;

				&_content {
					margin-top: 10px;

					.wrapper {
						display: flex;
						flex-direction: column;
						gap: 10px;
						max-height: 120px;
						min-height: 30px;
						overflow: auto;
						padding: 2px 0px;
					}

					.item {
						display: flex;
						justify-content: space-between;
						align-items: center;

						&-text {
							display: flex;
							flex-direction: column;
							gap: 0px;
						}
					}
				}

				&_hader {
					display: flex;
					justify-content: space-between;
					align-items: center;
				}
			}
		}

		.loader {
			margin: auto;
		}

		.label-select {
			margin-left: auto;
		}

		.upper-limit-clue {
			max-width: 300px;
			@media (max-width: $sm) {
				max-width: 200px;
			}
		}

		.input__secret {
			display: flex;
			flex-direction: column;
			gap: 8px;
			margin-bottom: -10px;
		}

		.wrapper {
			display: flex;
			flex-direction: column;
			overflow: auto;
			height: 100%;
			gap: 17px;
			margin-top: 14px;
			padding-right: 10px;
			margin-right: -10px;

			.switch-wrapper {
				margin-top: 0px;
				display: flex;
				align-items: center;
				gap: 14px;
			}
		}
	}
</style>
